import React, { FunctionComponent, Fragment } from 'react';
import { Route } from 'react-router-dom';
import FilterGroupCreateDialog from 'routes/FilterGroup/containers/FilterGroupCreateDialog';
import { FILTERS, FILTER_SETTING, SYSTEM_CONFIGURATION_ROUTE } from '../../constants';
import FiltersCreate from './containers/FiltersCreate';
import FiltersList from './containers/FiltersList';
import FiltersView from './containers/FiltersView';

interface Props {}

const Filters: FunctionComponent<Props> = () => {
  return (
    <Fragment>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${FILTER_SETTING}${FILTERS}`}>
        <FiltersList />
      </Route>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${FILTER_SETTING}${FILTERS}/create`}>
        <FiltersCreate />
      </Route>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${FILTER_SETTING}${FILTERS}/view`}>
        <FiltersView />
      </Route>
      <FilterGroupCreateDialog />
    </Fragment>
  );
};

export default Filters;
